<template>
    <form class="form-area col-12 col-lg-auto" autocomplete="off">
        <collapsible :title="$t('patient.form.requiredInformation')" :is-open="true">
            <div class="row">

                <div class="form-group col-12 col-lg-6">
                    <label for="patientFirstName">{{ $t('patient.form.firstName') }}:</label>
                    <input type="text" id="patientFirstName" v-model="patient.firstName" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="patientLastName">{{ $t('patient.form.lastName') }}:</label>
                    <input type="text" id="patientLastName" v-model="patient.lastName" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="patientBirthDate">{{ $t('patient.form.birthDate') }}:</label>
                    <date-picker v-model="patient.birthDate" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <span class="label">{{ $t('patient.form.gender') }}</span>
                    
                    <div class="input-radio inline">
                        <input type="radio" id="patientGenderMale" value="male" v-model="patient.gender" />
                        <label for="patientGenderMale">{{ $t('gender.male') }}</label>
                    </div>
                    <div class="input-radio inline">
                        <input type="radio" id="patientGenderFemale" value="female" v-model="patient.gender" />
                        <label for="patientGenderFemale">{{ $t('gender.female') }}</label>
                    </div>
                </div>

            </div>
        </collapsible>

        <collapsible :title="$t('patient.form.extraInformation')" :is-open="false">
            <div class="row">

                <div class="form-group col-12 col-lg-6">
                    <label for="patientIdentifier">{{ $t('patient.form.identifier') }}:</label>
                    <input type="text" id="patientIdentifier" v-model="patient.identifier" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="patientStayNumber">{{ $t('patient.form.stayNumber') }}:</label>
                    <input type="text" id="patientStayNumber" v-model="patient.stayNumber" />
                </div>

                <div class="form-group double-width col-12">
                    <label for="patientAddress">{{ $t('patient.form.address') }}:</label>
                    <input type="text" id="patientAddress" v-model="patient.address" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="patientCity">{{ $t('patient.form.city') }}:</label>
                    <input type="text" id="patientCity" v-model="patient.city" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="patientPostcode">{{ $t('patient.form.postcode') }}:</label>
                    <input type="text" id="patientPostcode" v-model="patient.postcode" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="patientState">{{ $t('patient.form.state') }}:</label>
                    <input type="text" id="patientState" v-model="patient.state" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="patientCountry">{{ $t('patient.form.country') }}:</label>
                    <input type="text" id="patientCountry" v-model="patient.country" />
                </div>

            </div>
        </collapsible>

        <collapsible :title="$t('patient.form.physicianInCharge')" :is-open="false">
            <div class="row">

                <div class="form-group double-width col-12">
                    <label for="physicianTitle">{{ $t('patient.form.title') }}</label>
                    <input type="text" id="physicianTitle" v-model="patient.physicianTitle" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="physicianFirstName">{{ $t('patient.form.firstName') }}:</label>
                    <input type="text" id="physicianFirstName" v-model="patient.physicianFirstName" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="physicianLastName">{{ $t('patient.form.lastName') }}:</label>
                    <input type="text" id="physicianLastName" v-model="patient.physicianLastName" />
                </div>

                <div class="form-group double-width col-6">
                    <label for="physicianAffiliation">{{ $t('patient.form.affiliation') }}</label>
                    <input type="text" id="physicianAffiliation" v-model="patient.physicianAffiliation" />
                </div>

                <div class="form-group double-width col-6">
                    <label for="physicianPhone">{{ $t('patient.form.phone') }}</label>
                    <input type="text" id="physicianPhone" v-model="patient.physicianPhone" />
                </div>

                <div class="form-group double-width col-12">
                    <label for="physicianAddress">{{ $t('patient.form.address') }}</label>
                    <input type="text" id="physicianAddress" v-model="patient.physicianAddress" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="physicianCity">{{ $t('patient.form.city') }}:</label>
                    <input type="text" id="physicianCity" v-model="patient.physicianCity" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="physicianPostcode">{{ $t('patient.form.postcode') }}:</label>
                    <input type="text" id="physicianPostcode" v-model="patient.physicianPostcode" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="physicianState">{{ $t('patient.form.state') }}:</label>
                    <input type="text" id="physicianState" v-model="patient.physicianState" />
                </div>

                <div class="form-group col-12 col-lg-6">
                    <label for="physicianCountry">{{ $t('patient.form.country') }}:</label>
                    <input type="text" id="physicianCountry" v-model="patient.physicianCountry" />
                </div>

            </div>
        </collapsible>
    </form>

    <div class="data-area col-12 col-lg intro-statements">
        <p>{{ $t('patient.formData.welcome') }}</p>

        <p class="spacer">
            <img src="@/assets/images/logo/logo-color.svg" alt="" />
        </p>

        <p>{{ $t('patient.formData.graphs') }}</p>

        <p class="spacer">
            <img src="@/assets/images/logo/logo-color.svg" alt="" />
        </p>

        <p v-html="$t('patient.formData.tooltips')"></p>
    </div>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue';
import { usePatientStore } from '@/store/patient';
import Collapsible from '@/components/Collapsible.vue';
import DatePicker from '@/components/DatePicker.vue';
import { useRequestDataStore } from '@/store/request-data';

export default defineComponent({
    components: { Collapsible, DatePicker },

    setup()
    {
        const patient = usePatientStore();
        const requestDataStore = useRequestDataStore();

        watch([() => patient.birthDate, () => patient.gender], () => {
            requestDataStore.populateDataFromDrugAndPatientData();
        });

        return { patient };
    }
})
</script>

<style lang="scss" scoped>
    .intro-statements {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        text-align: center;
        font-size: 1.5rem;
    }
</style>
